module.exports = __webpack_public_path__ + "static/media/opel.94a46970.png";